import api from "../../services/api";
import { cachedApi } from "../../services/cachedApi";


const save = async (data) => {
    const { data: responseData } = await api.request({
        url: '/companies',
        method: 'POST',
        data
    });
    return responseData;
}

const findAll = async (id) => {
    const { data } = await api.request({
        url: `/companies`,
        method: 'GET'
    });
    return data;
}

const list = async (id) => {
    const { data } = await api.request({
        url: `/companies/list`,
        method: 'GET'
    });
    return data;
}

const find = async (id) => {
    const { data } = await api.request({
        url: `/companies/${id}`,
        method: 'GET'
    });
    return data;
}

const update = async (data) => {
    const { data: responseData } = await api.request({
        url: `/companies/${data.id}`,
        method: 'PUT',
        data
    });
    // Troca de plano pelo super admin: o cache de /companies/listPlan fica velho.
    cachedApi.plans.invalidate(data.id);
    return responseData;
}

const remove = async (id) => {
    const { data } = await api.request({
        url: `/companies/${id}`,
        method: 'DELETE'
    });
    return data;
}

const updateSchedules = async (data) => {
    const { data: responseData } = await api.request({
        url: `/companies/${data.id}/schedules`,
        method: 'PUT',
        data
    });
    return responseData;
}

// Objeto estavel no escopo do modulo: as funcoes nao dependem de estado nem de
// props, e uma referencia nova a cada render faria qualquer useEffect/useCallback
// que dependa delas rodar em loop.
const companiesApi = {
    save,
    update,
    remove,
    list,
    find,
    findAll,
    updateSchedules
};

const useCompanies = () => companiesApi;

export default useCompanies;